import React from 'react'

import { Modal, Select } from 'antd'
import { Done, Edit } from '@mui/icons-material'
import { useAtom } from 'jotai'
import { genresAtom } from '../../../State/Musician/genresAtom'
import { Genre } from '../../../Api/Lirari/Types/genre'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import { useAuth0 } from '@auth0/auth0-react'
import userClient from '../../../Api/Lirari/Clients/userClient'
import { unauthenticatedUserAtom } from '../../../State/Musician/unauthenticatedUserAtom'
import { useParams } from 'react-router-dom'

const MusicianGenres = ({ editMode }: { editMode: boolean }) => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()

  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [myUser, setMyUser] = useAtom(myUserAtom)
  const [genres] = useAtom(genresAtom)
  const [searchedGenres, setSearchedGenres] = React.useState<Genre[]>([])
  const [unauthenticatedUser] = useAtom(unauthenticatedUserAtom)
  const { uid: userId } = useParams()

  const profileGenres =
    userId == myUser.id
      ? myUser.userGenres
      : userId == unauthenticatedUser.id
        ? unauthenticatedUser.userGenres
        : [
            { genre: { name: 'Palestinian', id: '1' } },
            { genre: { name: 'Arabic', id: '2' } },
            { genre: { name: 'Traditional', id: '3' } },
          ]

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleSubmit = async () => {
    if (myUser.id && myUser.userGenres && isAuthenticated) {
      const response = await userClient.overwriteUserGenres(
        myUser.id,
        myUser.userGenres.map((ug) => ug.genre),
        await getAccessTokenSilently({
          authorizationParams: {
            scope: 'user:all',
          },
        }),
      )
      if (response) {
        setMyUser({ ...myUser, userGenres: myUser.userGenres })
      }
    }
    setIsModalOpen(false)
  }

  const onSelect = (value: string) => {
    const genre = genres.find((genre) => genre.name == value)
    if (genre) {
      setMyUser({ ...myUser, userGenres: [...myUser.userGenres, { genre: genre }] })
    }
    setSearchedGenres(genres)
  }

  const onDeselect = (value: string) => {
    const updatedGenres = myUser.userGenres.filter((userGenre) => userGenre.genre.name != value)
    setMyUser({ ...myUser, userGenres: updatedGenres })
    setSearchedGenres(genres)
  }

  const onSearch = (e: string) => {
    const filteredGenres = e ? genres.filter((genre) => genre.name.toLowerCase().includes(e.toLowerCase())) : undefined
    if (filteredGenres) setSearchedGenres(filteredGenres)
  }

  React.useEffect(() => {
    setSearchedGenres(genres)
  }, [genres])

  const EditGenresModal = (
    <Modal centered open={isModalOpen} closable={false} footer={[]}>
      <div className="flex flex-col items-center">
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          placeholder="Please select genres"
          filterOption={false}
          onSearch={onSearch}
          onSelect={onSelect}
          onDeselect={onDeselect}
          defaultValue={myUser.userGenres.map((userGenre) => userGenre.genre.name)}
          options={searchedGenres.map((genre) => ({ id: genre.id, value: genre.name }))}
        />

        <button
          className="flex justify-center h-12 w-12 rounded-full border-none bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black p-0 mt-2.5 "
          onClick={handleSubmit}
        >
          <Done className="self-center" />
        </button>
      </div>
    </Modal>
  )

  return (
    <div
      className={`flex flex-col items-center rounded-lg w-[100%] max-[1020px]:min-h-[370px] max-h-[340px] px-3.5 mb-0 mx-4 lg:mx-0 lg:pb-0 pb-[4vh] bg-gradient-to-b from-[#494949] to-[#242424]`}
    >
      <p className="py-[5px] title-small">Genres</p>
      <div className={`flex flex-wrap gap-2 ${editMode ? 'cursor-pointer' : ''}`}>
        <>
          {profileGenres.map((userGenre) => (
            <p key={userGenre.genre.id} className="flex gap-2.5 mx-2 mt-0 py-2 px-5 rounded-3xl bg-black">
              {userGenre.genre.name}
            </p>
          ))}

          {editMode ? (
            <p className="flex gap-2.5 mx-2 mt-0 py-2 px-5 rounded-3xl bg-black cursor-pointer" onClick={showModal}>
              <Edit />
            </p>
          ) : null}
        </>
      </div>
      {EditGenresModal}
    </div>
  )
}

export default MusicianGenres
